module.exports = __webpack_public_path__ + "static/img/kefu1.ba5341e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/kefu1.png
// module id = ebcv
// module chunks = 1